module.exports = "<lifeSpaBookingConfirmation></lifeSpaBookingConfirmation>"